
"use client";

import Navbar from '@/components/CommonComponent/navbar';
import React, { useEffect, useRef, useState } from 'react';
import { IoIosSearch } from 'react-icons/io';
import { usePathname } from 'next/navigation';
import axios from 'axios';
import { BASE_URL } from '@/util/api';
import Link from 'next/link';
import Image from 'next/image';
import { IoReturnUpBackOutline } from 'react-icons/io5';
import Loader from '@/components/CommonComponent/loader';
import { StyledWrapper } from '@/components/Styled'
import Sites from '@/Data/Sites.json'
import ResultTable from '@/components/OtherComponent/ResultTable';
import { motion } from 'framer-motion'
import Popup from '@/components/CommonComponent/Popup'
import { GoArrowUpRight } from 'react-icons/go';
import { MdStar } from 'react-icons/md';
import toast from 'react-hot-toast';
import KeywordPlanner from '@/components/OtherComponent/Keywordsuggestion';
import {  message } from "antd";
import { useRouter } from 'next/navigation'
import {city} from '@/Data/company-city'

declare global {
    interface Window {
        grecaptcha: any;
    }
}
const Tool = ({ tools, tools_body }: any) => {
    // console.log(tools)
    const router = useRouter()

    const [innerloading, setinnerloading] = useState<any>(true)
    const pathname = usePathname();
    const segments = pathname!.replace(/\/$/, '').split('/');
    const lastSegment = segments.pop();
    const [loading, setLoading] = useState<boolean>(false); // Loading state
    const [error, setError] = useState<string | null>(null); // Error state
    const [result, setResult] = useState<any>(null); // Result state
    const [currentTool, setCurrentTool] = useState<any[]>([]);
    const [showresult, setshowresult] = useState<any>(false)
    const [displayedRows, setDisplayedRows] = useState<any[]>([]); // Initially empty
    const [showPopup, setShowPopup] = useState(false);
    const formRef = useRef<any>(null);

    // Load the reCAPTCHA script dynamically on mount
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX`;
        script.async = true;
        script.onload = () => {
           
        };
        script.onerror = () => {
            message.error("Failed to load reCAPTCHA script. Please refresh the page.");
        };
        document.body.appendChild(script);
    }, []);
    const handleSubmitForm = async (values: any) => {
        if (!window.grecaptcha) {
            message.error("reCAPTCHA failed to load. Please refresh the page.");
            return;
        }
        try {
            const token = await window.grecaptcha.execute("6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX", { action: "submit" });
            const selectedServices = Object.entries(values)
                .filter(([key, value]) => key.startsWith('service_') && value === true)
                .map(([key]) => key.replace('service_', ''))
                .join(';');
            const response = await fetch(
                "https://api.hsforms.com/submissions/v3/integration/submit/20095080/2aeda8d3-d0a1-4624-87f7-39fea7a4d68d",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        fields: [
                            { name: "firstname", value: values.firstname },
                            // { name: "lastname", value: values.lastname },
                            { name: "email", value: values.email },
                            { name: "phone", value: values.phoneNumber },
                            // { name: "select_services", value: selectedServices },
                            // { name: "monthly_spent_budget_for_digital_marketing", value: values.monthly_spent_budget_for_digital_marketing },
                            // { name: "0-2/facebook_company_page", value: values.social_media_profiles },
                            { name: "0-2/website", value: values.website },
                            { name: "message", value: values.message },
                            // { name: "recaptcha_token", value: token },  // Send the reCAPTCHA v3 token
                        ],
                    }),
                }
            );
            if (response.ok) {
                message.success("Form submitted successfully!");
                formRef.current.resetFields();
                router.push('/thank-you');


            } else {
                const errorData = await response.json();
                // //console.error("Error submitting form:", errorData);
                message.error("Failed to submit form. Please try again.");
            }
        } catch (error) {
            // //console.error("Error submitting form:", error);
            message.error("An unexpected error occurred. Please try again.");
        }
    };
    useEffect(() => {
        // Set a timer to show the popup after 5 seconds
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 3000);
        // Cleanup the timer if the component unmounts
        return () => clearTimeout(timer);
    }, []);
    const [formData, setFormData] = useState({
        url: '',
        keywords: '',
        metaTitle: '',
        description: '',
        depth: '',
        pageno: '',
        useragent: '',
        allowpath: '',
        disallowpath: '',
        crawlDelay: '',
        sitemapUrl: '',
        strategy_input: '',
        country_code: ''

    });
    const progress = (displayedRows.length / Sites.sites.length) * 100;
    const displayRowsOneByOne = (rows: any[]) => {
        let i = 0;
        const appendRow = () => {
            if (i < rows.length) {
                setDisplayedRows((prevRows) => [...prevRows, rows[i]]);
                i++;
                // Generate a random delay between 5 and 20 seconds
                const randomDelay = Math.floor(Math.random() * (4000 - 2000 + 1)) + 2000
                setTimeout(appendRow, randomDelay); // Schedule the next row with random delay
                if
                    (
                    i == rows.length - 1
                ) {
                    setinnerloading(false); //
                }
            }
        };
        appendRow();
        // Start the recursive process
    };
    useEffect(() => {
        if (result?.length > 0) {
            setDisplayedRows([]); // Reset displayed rows
            displayRowsOneByOne(result);
        }
    }, [result]);
    const checkBacklink = () => {
        if (!formData.url) return; // Ensure the URL is valid before proceeding
        const formattedDomain = formData.url.replace(/https?:\/\/|www\./g, ""); // Remove protocol and 'www.'
        setshowresult(true); // Show the result section
        setLoading(true); // Set loading to true
        setError(null);        // Use setTimeout to delay the result display
        setTimeout(() => {
            setLoading(false); // Stop loading after 3 seconds
            // Show the result section
            const formattedResults = Sites?.sites.map((site: any, index: number) => ({
                id: index + 1, // Incremental ID
                Page: site.replace("{domain}", formattedDomain), // Replace `{domain}` in URLs
                Status: "Success", // Example status
            }));
            setResult(formattedResults || []);
            setshowresult(true) // Update the state with the formatted results
        }, 2000); // 3 seconds delay
    };
    useEffect(() => {
        const foundTool = tools?.map((category: any) =>
            category.tools.find((tool: any) => tool.slug_link === lastSegment)
        ).find((tool: any) => tool !== undefined);
        setCurrentTool(foundTool ? [foundTool] : []); // Wrap in an array for consistency
    }, [tools, lastSegment]);
    const fetchResult = async () => {
        setshowresult(true)
        setLoading(true); // Set loading to true
        setError(null); // Reset error state
        // console.log('sending data is ', { ...formData })
        try {
            const response = await axios.post(`${BASE_URL}tools/${lastSegment}`, {
                ...formData
            });
            setResult(response.data); // Save result in state
            setinnerloading(true)
            // console.log('resposned data ----', response.data);
        } catch (error: any) {
            setError(error.message); // Set error message
            // console.log("Service error", error.message);
        }
        finally {
            setLoading(false); // Set loading to false
        }
    };
    const [inputValue, setInputValue] = useState('')
    const handleInputChange = (e: any) => {
        setInputValue(e.target.value)
    }
    const handleGetResults = async () => {
        if (inputValue.trim() === '') {
            toast.error('Please enter some text or a URL to analyze')
            return
        }
        setResult('')
        setshowresult(true)
        setLoading(true); // Set loading to true
        setError(null);
        try {
            // console.log('handle result called')
            // console.log('input value:', inputValue)
            const response = await axios.post('https://www.w3era.com/api/calculate-readability/', {
                input_data: inputValue,
                is_url: activeTab === 'website'
            })
            // console.log('the result is ', response.data)
            const resultWithoutIsUrl = { ...response.data };
            delete resultWithoutIsUrl.is_url;
            setResult(resultWithoutIsUrl);
        } catch (error) {
            // //console.error('Error fetching readability scores:', error)
            toast.error('An error occurred while analyzing the text')
        }
        finally {
            setLoading(false)
        }
    }
    const handleSubmit = (e: React.FormEvent) => {
        setResult(null)
        fetchResult(); // Call fetch on submit
        window.scrollTo(0, 0);  // Scroll to the top of the page
    };
    const [searchTerm, setSearchTerm] = useState("");
    const [countries, setCountries] = useState<any>([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleClear = () => {
        setFormData({
            url: '',
            keywords: '',
            metaTitle: '',
            description: '',
            depth: '',
            pageno: '',
            useragent: '',
            allowpath: '',
            disallowpath: '',
            crawlDelay: '',
            sitemapUrl: '',
            strategy_input: ""
            ,
            country_code: '',
        });
        setResult(null);
        setshowresult(false);
    };
    useEffect(() => {
        const fetchCountries = async () => {
            if (searchTerm.length < 3) {
                setCountries([]);
                setShowDropdown(false);
                return;
            }
            setLoading(true);
            try {
                const response = await fetch(
                    `https://restcountries.com/v3.1/name/${searchTerm}`
                );
                const data = await response.json();
                if (response.ok) {
                    // console.log('the locations are', data)
                    setCountries(data);
                    setShowDropdown(true);
                } else {
                    setCountries([]);
                }
            } catch (error) {
                // //console.error("Error fetching countries:", error);
                setCountries([]);
            } finally {
                setLoading(false);
            }
        };
        const timeoutId = setTimeout(fetchCountries, 500); // Debounce API calls
        return () => clearTimeout(timeoutId);
    }, [searchTerm]);
    const handleSelectCountry = (country: any) => {
        setFormData((prevState) => ({
            ...prevState,
            country_code: country?.cca2, // Use `cca2` for country code
        }));
        setSearchTerm(country.name.common); // Update input field with country name
        setShowDropdown(false);
    };
    const [activeTab, setActiveTab] = useState('text')
    return (
        <>
            {
                !tools && currentTool &&
                <Loader />
            }
            {
                tools && currentTool &&
                <div>
                    
                    {
                        showPopup && (
                            <motion.div
                                className="fixed md:bottom-10 bottom-4 bg-white border-[1px] border-slate-300 right-4 md:right-10 p-2 z-50  rounded-2xl  shadow-lg"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0, opacity: 0 }}
                                transition={{ duration: 0.3, ease: 'easeInOut' }}
                            >
                                <Popup />
                                <div className="flex ml-2 items-center gap-4 mt-6">
                                    <Link href="https://app.w3era.com/" target='_blank'>
                                        <button className="redirect-to-app_w3era-tools-popup">
                                            Explore Tools Now
                                        </button>
                                    </Link>
                                    <button
                                        className="text-blue font-bold underline"
                                        onClick={() => {
                                            setShowPopup(false);
                                        }}
                                    >
                                        Skip for now
                                    </button>
                                </div>
                            </motion.div>
                        )
                    }
                    <div className='w-full'>
                        <div className='w-full bg-no-repeat bg-center min-h-[40vh] bg-[url("/images/tool-bg.png")] py-9 flex flex-col justify-center items-center'>
                            <div className='text-[32px] lg:text-[44px] font-bold text-white'>{currentTool[0]?.title || ''}</div>
                        </div>
                    </div>
                    <div className='mt-4 w-full px-4 xl:px-0 xl:w-[95%]  2xl:w-[75%] mx-auto'>
                        <div className='flex  gap-3'>
                            <div className='w-fit'>
                                <Link href={'/seo-tools'}>
                                    <button className='bg-lightpink text-pink mb-7 p-2 px-4 text-[18px] font-medium flex justify-center gap-3 rounded-lg items-center'>
                                        <IoReturnUpBackOutline className='text-[24px]' /> Back
                                    </button>
                                </Link>
                            </div>
                            <button onClick={handleClear}
                                className=' h-fit px-7 py-[9px] rounded-md bg-lightpink text-pink font-medium  hover:bg-pink hover:text-white duration-200'>Clear</button>
                        </div>
                        <div className='rounded-xl p-7 shadow-xl border-slate-100 border-[1px]'>
                            <div className='bg-grey px-4 py-2 rounded-lg w-full flex items-center gap-3'>
                                <div className='w-[93px] h-[93px] bg-white rounded-full flex justify-center items-center'>
                                    <Image src={currentTool?.[0]?.image || ''} height={53} width={53} alt={currentTool?.[0]?.image_alt} />
                                </div>
                                <div>
                                    <p className='text-homeblack font-semibold text-[18px] md:text-[20px]'>{currentTool?.[0]?.title}</p>
                                </div>
                            </div>
                            {
                                currentTool[0]?.slug_link === 'readability-checker' &&
                                <div className="p-6">
                                    <div className="border-b mb-6">
                                        <div className="flex gap-8">
                                            <button
                                                onClick={() => setActiveTab('text')}
                                                className={`pb-4 px-1 relative font-medium ${activeTab === 'text' ? 'text-blue' : 'text-gray-600'}`}
                                            >
                                                Analyze Text
                                                {activeTab === 'text' && (
                                                    <motion.div
                                                        layoutId="activeTab"
                                                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue"
                                                    />
                                                )}
                                            </button>
                                            <button
                                                onClick={() => setActiveTab('website')}
                                                className={`pb-4 px-1 relative font-medium ${activeTab === 'website' ? 'text-blue' : 'text-gray-600'}`}
                                            >
                                                Analyze Website
                                                {activeTab === 'website' && (
                                                    <motion.div
                                                        layoutId="activeTab"
                                                        className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue"
                                                    />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="space-y-6">
                                        <div>
                                            <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                                                {activeTab === 'text' ? 'Enter text to analyze' : 'Enter website URL'} <MdStar className="text-red-500" />
                                            </label>
                                            <textarea
                                                placeholder={activeTab === 'text' ? 'Enter your text here...' : 'https://example.com'}
                                                className="w-full px-3 py-2 bg-lightblue rounded-md outline-none focus:ring-2 focus:ring-blue"
                                                value={inputValue}
                                                onChange={handleInputChange}
                                                rows={5}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-6 flex justify-start">
                                        <button
                                            onClick={handleGetResults}
                                            disabled={loading}
                                            className="px-8 py-2 bg-pink text-white rounded-lg flex items-center gap-2 hover:scale-105 smooth3 transition-colors"
                                        >
                                            {loading ? 'Checking Readability...' : 'Check Readability'}
                                        </button>
                                    </div>
                                </div>
                            }
                            {
                                !(currentTool[0]?.slug_link === 'keywords-research-tool' || currentTool[0]?.slug_link === 'keywords-suggestion-tool' || currentTool[0]?.slug_link === 'robots-txt-generator' ||
                                    currentTool[0]?.slug_link === 'readability-checker' ||
                                    currentTool[0]?.slug_link === 'what-is-my-browser' || currentTool[0]?.slug_link === 'my-ip-address') && (
                                    <div className='rounded-lg w-full border-grey border-[2px] flex justify-between items-center p-3 px-6 mt-4  bg-white'>
                                        <input
                                            type="text"
                                            className='text-textGrey w-full dark:bg-white border-none outline-none text-[18px]'
                                            placeholder='Enter url'
                                            name='url'
                                            onChange={handleChange}
                                            value={formData.url} // Control input value
                                        />
                                    </div>
                                )
                            }
                            {
                                (currentTool[0]?.slug_link === 'keyword-position-checker' || currentTool[0]?.slug_link === 'keywords-suggestion-tool' || currentTool[0]?.slug_link ===
                                    'meta-tag-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='Enter Your Keyword'
                                        className='w-full dark:bg-white  border-none outline-none' name='keywords' onChange={handleChange} value={formData?.keywords} />
                                </div>)
                            }
                            <div>
                                {(currentTool[0]?.slug_link === 'keyword-position-checker') && (
                                    <div className="mt-6">
                                        <div className="flex items-center gap-4 text-sm text-homeblack mb-1">
                                            <div className="flex items-center gap-2">
                                                <span className="w-5 h-5 bg-homtext-homeblack rounded flex items-center justify-center">📍</span>
                                                Select location <MdStar className="text-red-500" />
                                            </div>
                                        </div>
                                        <div className="mt-4 relative location-dropdown">
                                            <input
                                                type="text"
                                                name="country"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                    setShowDropdown(true);
                                                }}
                                                placeholder="Enter country name..."
                                                autoComplete="off"
                                                className="w-full dark:bg-white p-3 border border-grey rounded-lg outline-none"
                                                readOnly={!!formData.country_code}
                                            />
                                            {loading && <p className="text-gray-500 text-sm mt-1">Loading...</p>}
                                            {showDropdown && countries.length > 0 && !formData.country_code && (
                                                <ul className="absolute z-10 w-full mt-1 bg-white border border-grey rounded-lg shadow-lg max-h-60 overflow-auto">
                                                    {countries.map((country: any) => (
                                                        <li
                                                            key={country.cca2}
                                                            className="px-4 py-2 cursor-pointer hover:bg-lightpink hover:text-pink transition-colors duration-150"
                                                            onClick={() => handleSelectCountry(country)}
                                                        >
                                                            {country.name.common} ({country.cca2})
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        {formData.country_code && (
                                            <div className="mt-2 p-2 bg-lightpink text-pink rounded-lg flex justify-between items-center">
                                                <span>Selected: {countries.find((c: any) => c.cca2 === formData.country_code)?.name.common} ({formData.country_code})</span>
                                                <button
                                                    onClick={() => {
                                                        setFormData((prevState) => ({ ...prevState, country_code: '' }));
                                                        setSearchTerm('');
                                                    }}
                                                    className="text-pink hover:text-red-600 focus:outline-none"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {/* ... rest of the component ... */}
                            </div>
                            {
                                (currentTool[0]?.slug_link === 'meta-tag-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='Enter Meta Title' className='w-full dark:bg-white  border-none outline-none' name='metaTitle' onChange={handleChange}
                                        value={formData?.metaTitle} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'keywords-research-tool') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <KeywordPlanner />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'meta-tag-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='Enter Meta Description' className='w-full dark:bg-white border-none outline-none' name='description' onChange={handleChange}
                                        value={formData?.description} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'spider-simulator') &&
                                (<div className='mt-4 border-grey flex justify-between border-[2px] rounded-lg p-6 w-full '>
                                    <input type="number" placeholder='Enter Crawler Depth' className='w-full dark:bg-white border-none outline-none' name='depth' onChange={handleChange} value={formData?.depth} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'spider-simulator') &&
                                (<div className='mt-4 border-grey flex justify-between border-[2px] rounded-lg p-6 w-full '>
                                    <input type="number" placeholder='Enter Number of Pages' className='w-full dark:bg-white border-none outline-none' name='pageno'
                                        value={formData?.pageno} onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'robots-txt-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder=' Enter user agents Seprated By Coma(,)' className='w-full dark:bg-white border-none outline-none'
                                        name='useragent' value={formData?.useragent} onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'robots-txt-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='   Enter disallow paths Seprated By Coma(,)' className='w-full dark:bg-white border-none outline-none' name='disallowpath'
                                        value={formData?.disallowpath}
                                        onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'robots-txt-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='   Enter allow paths Seprated By Coma(,)' name='allowpath' value={formData?.allowpath}
                                        className='w-full dark:bg-white  border-none outline-none' onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'page-speed-checker' || currentTool[0]?.slug_link === 'pagespeed-insights-checker') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='   Enter the strategy (mobile/desktop)' name='strategy_input' value={formData?.strategy_input}
                                        className='w-full dark:bg-white  border-none outline-none' onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'robots-txt-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='   Enter Crawler Delay' className='w-full dark:bg-white
                                    border-none outline-none' value={formData?.crawlDelay} name='crawlDelay' onChange={handleChange} />
                                </div>)
                            }
                            {
                                (currentTool[0]?.slug_link === 'robots-txt-generator') &&
                                (<div className='mt-4 border-grey border-[2px] rounded-lg p-6 w-full '>
                                    <input type="text" placeholder='Enter sitemap URL' className='w-full dark:bg-white border-none outline-none' name='sitemapUrl'
                                        value={formData?.sitemapUrl} onChange={handleChange} />
                                </div>)
                            }
                            {showresult && <div className=' rounded-xl p-7  mt-5 border-slate-100 border-[1px]'>
                                {error && <p className="text-center text-red-500">{error}</p>}
                                {result && (
                                    <div className=" p-2 overflow-auto">
                                        {
                                            lastSegment == 'backlink-maker' &&
                                            <div className='w-full max-h-[400px] overflow-y-auto relative'>
                                                {/* Progress Bar Container */}
                                                <div className='sticky top-0 z-10 bg-gray-200 flex mb-4 h-4 rounded-full'>
                                                    <div
                                                        className='bg-blue h-full flex rounded-full items-center justify-center text-white'
                                                        style={{ width: `${progress}%`, transition: 'width 0.5s ease' }}
                                                    >
                                                        {Math.round(progress)}%
                                                    </div>
                                                </div>
                                                {/* Scrollable Table */}
                                                <div className='overflow-x-auto'>
                                                    <table className='table-auto w-full min-w-[500px] border-collapse border border-gray-300'>
                                                        <thead>
                                                            <tr className='bg-gray-100 border-b'>
                                                                <th className='p-2 border-r'>S.no</th>
                                                                <th className='p-2 border-r'>Pages contain backlink</th>
                                                                <th className='p-2'>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {displayedRows.map((elem: any, index: number) => (
                                                                <tr key={index} className='border-b'>
                                                                    <td className='p-2 text-center border-r'>{index + 1}</td>
                                                                    <td className='p-2 border-r'>
                                                                        <a
                                                                            href={elem?.Page}
                                                                            target='_blank'
                                                                            rel='noopener noreferrer'
                                                                            className='text-blue-500 hover:text-blue duration-75 hover:underline'
                                                                        >
                                                                            {elem?.Page}
                                                                        </a>
                                                                    </td>
                                                                    <td className={`p-2 ${elem?.Status === 'Success' ? 'text-green-600' : 'text-red-600'}`}>
                                                                        {elem?.Status}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* Loading Indicator */}
                                                {innerloading && (
                                                    <div className='flex mt-4 justify-center items-center'>
                                                        <div className='loader'></div>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        {
                                            <div>
                                                {!(lastSegment === 'backlink-maker' || lastSegment === 'keyword-position-checker') && <ResultTable result={result} lastSegment={lastSegment} />}
                                            </div>
                                        }
                                        {
                                            lastSegment === 'keyword-position-checker' &&
                                            <table className="w-full border border-slate-500 text-center">
                                                <thead>
                                                    <tr>
                                                        {Object.keys(result[0]).map((key) => (
                                                            <th key={key} className="border border-slate-200 capitalize p-2">
                                                                {key.replace(/_/g, " ")}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {result.map((item: any, rowIndex: any) => (
                                                        <tr key={rowIndex}>
                                                            {Object.values(item).map((value: any, colIndex) => (
                                                                <td key={colIndex} className="border border-slate-200 p-2">
                                                                    {value}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                )}
                                {loading && <div className=" flex justify-center items-center">
                                    <div className=" loader"></div>
                                </div>
                                }
                            </div>}
                            <div className='flex justify-start items-center gap-2'>
                                {lastSegment === 'website-seo-analyzer' ? (
                                    <div className="mt-4 w-fit">
                                        <button
                                            type="submit"
                                            className="text-pink text-[18px] bg-white gap-3 flex items-center rounded-full p-[2px] mb-4 border-lightpink border-[2px] font-medium group hover:bg-lightpink transition-all duration-300"
                                        >
                                            <span className="min-w-[45px] h-[45px] flex bg-lightpink justify-center items-center rounded-full border-lightpink border-[1px] transform transition-transform duration-300 group-hover:bg-pink group-hover:rotate-45 group-hover:translate-x-2">
                                                <GoArrowUpRight className="-rotate-30 group-hover:text-white text-[28px] text-pink" />
                                            </span>
                                            <span className="tool-analyzed">
                                                <Link href="https://app.w3era.com/">Check</Link>
                                            </span>
                                        </button>
                                    </div>
                                ) : lastSegment === 'keywords-research-tool' ? (
                                    <div className="mt-4 w-fit">
                                        <button
                                            type="submit"
                                            className="text-pink text-[18px] bg-white gap-3 flex items-center rounded-full p-[2px] mb-4 border-lightpink border-[2px] font-medium group hover:bg-lightpink transition-all duration-300"
                                        >
                                            <span className="min-w-[45px] h-[45px] flex bg-lightpink justify-center items-center rounded-full border-lightpink border-[1px] transform transition-transform duration-300 group-hover:bg-pink group-hover:rotate-45 group-hover:translate-x-2">
                                                <GoArrowUpRight className="-rotate-30 group-hover:text-white text-[28px] text-pink" />
                                            </span>
                                            <span className="tool-analyzed">
                                                <Link href="https://app.w3era.com/tools/keyword-research">Sign Up For Deatiled Analysis</Link>
                                            </span>
                                        </button>
                                    </div>)
                                : (
                                    <div>
                                        {(lastSegment !== 'readability-checker' ) && <div
                                            className="mt-4 w-fit"
                                            onClick={lastSegment === 'backlink-maker' ? checkBacklink : handleSubmit}
                                        >
                                            <button
                                                type="submit"
                                                className="text-pink text-[18px] bg-white gap-3 flex items-center rounded-full p-[2px] mb-4 border-lightpink border-[2px] font-medium group hover:bg-lightpink transition-all duration-300"
                                            >
                                                <span className="min-w-[45px] h-[45px] flex bg-lightpink justify-center items-center rounded-full border-lightpink border-[1px] transform transition-transform duration-300 group-hover:bg-pink group-hover:rotate-45 group-hover:translate-x-2">
                                                    <GoArrowUpRight className="-rotate-30 group-hover:text-white text-[28px] text-pink" />
                                                </span>
                                                <span className="tool-analyzed">Check</span>
                                            </button>
                                        </div>}
                                    </div>
                                )
                                }
                            </div>
                        </div>
                    </div>
                    <div className='bg-white relative flex justify-between gap-3 xl:w-[77%] mx-auto px-4 w-full my-10'>
                    {tools_body?.body && <div className='w-full rounded-xl border-slate-100 border-[1px] h-full py-8 px-6 shadow-lg'>
                            <div>
                                <div className='my-8 md:px-4'>
                                    <StyledWrapper>
                                        <div dangerouslySetInnerHTML={{ __html: tools_body?.body || 'body is null' }} />
                                    </StyledWrapper>
                                </div>
                            </div>
                        </div>}
                        <aside>
                        </aside>
                    </div>
                    <div className="bg-white flex justify-between gap-3 xl:w-[79%] mx-auto px-4 w-full my-10">
            <div className="w-full rounded-xl bg-lightblue border-slate-100 border-[1px] h-full py-8 px-2 lg:px-6 shadow-lg">
                <p className="text-homeblack font-bold text-center mb-5">Best SEO Company – Find Out Tops the List</p>
                <div className="flex justify-center flex-wrap gap-4">
                    {city?.map((elem:any, index:number) => (
                        <Link
                            key={index}
                            href={elem.link}
                            className="py-2 lg:py-4 border-[1px] hover:text-pink border-blue text-[16px] lg:text-[18px]
                        bg-white flex justify-center hover:border-pink items-center w-fit lg:w-[22%]
                            text-blue font-bold hover:bg-lightpink px-4 rounded hover:bg-blue-600 transition duration-300"
                        >
                            {elem?.city}
                        </Link>
                    ))}
                </div>
            </div>
        </div>
                </div>
            }
        </>
    );
}
export default Tool;






